import { render, staticRenderFns } from "./ChecklistsChecklistItemType.vue?vue&type=template&id=bbcbebb6&scoped=true"
import script from "./ChecklistsChecklistItemType.vue?vue&type=script&lang=js"
export * from "./ChecklistsChecklistItemType.vue?vue&type=script&lang=js"
import style0 from "./ChecklistsChecklistItemType.vue?vue&type=style&index=0&id=bbcbebb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcbebb6",
  null
  
)

export default component.exports